import { useMsal } from '@azure/msal-react';
import LogoBrsp from '../../assets/images/brightspeed-logo-color.png';
import ButtonMailto from '../../components/button-mailto';
import { loginRequest } from '../../config/authConfig';
const Login: React.FC = () => {
	const { instance } = useMsal();
	const handleLogin = async () => {
		// Initiate login
		instance.loginRedirect(loginRequest).catch((e) => {
			console.error(e);
		});
	};
	return (
		<div className="flex min-h-[100vh] flex-1 flex-col justify-center items-center px-6 py-12 lg:px-8">
			<div className="sm:mx-auto sm:w-full sm:max-w-sm">
				<div className="w-full shadow-md border border-gray-100 rounded">
					<div className="flex justify-center items-center border-b border-gray-100 py-4">
						<img src={LogoBrsp} alt="Brightspeed" />
					</div>
					<div className="p-4 pt-6 text-center text-gray-900">
						<h2 className="uppercase font-bold text-lg text-gray-500">
							PLEASE SIGN IN USING YOUR <br /> BRIGHTSPEED CREDENTIALS
						</h2>
						<p className="my-8 text-sm">
							For additional technical support, please contact <br />
							<span className="font-bold italic">
								<ButtonMailto
									label="sivunnaidu.gullipalli@brightspeed.com"
									mailto="mailto:sivunnaidu.gullipalli@brightspeed.com"
								/>
							</span>
						</p>
						<div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
							<button
								type="button"
								onClick={() => handleLogin()}
								className="flex w-full justify-center rounded-md bg-sky-500 px-3 py-2 text-md font-medium leading-6 text-white shadow-sm hover:bg-sky-600 gap-2"
							>
								Sign In
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Login;
